import * as React from 'react';

export function LoadingSpinner(props: { 'data-testid'?: string }) {
	return (
		<div data-testid={props['data-testid']}>
			<div className="loading-in-progress">
				<div className="loading-spinner" />
			</div>
		</div>
	);
}
